module.exports = __webpack_public_path__ + "img/xr2_banner_m.baab3d0f.jpg";